import React from 'react';
import './APS100.css';

const APS100 = () => {
    return (
        <div className="aps100-container">
            <div className="titleaps100">
                <a href="https://engineering.calendar.utoronto.ca/course/aps100h1" target="_blank" rel="noopener noreferrer">
                    <p>APS100: Orientation to Engineering</p>
                </a>
            </div>
            <p>
                This course is designed to help students transition into first-year engineering studies and to develop and apply a greater understanding of the academic learning environment, the field of engineering, and how the fundamental mathematics and sciences are used in an engineering context. Topics covered include: study skills, time management, problem solving, successful teamwork, effective communications, exam preparation, stress management and wellness, undergraduate research, extra- and co-curricular involvement, engineering disciplines and career opportunities, and applications of math and science in engineering.
            </p>
            <p>
                I did not take notes for this course.
            </p>
        </div>
    );
};

export default APS100;